import React from 'react'
import { FavoriteIcon } from 'components/Utils/Icons'
import { SectionHeader } from './'

export const FAVORITE_CHANNELS_SECTION_ID = `favorites-title`

export type FavoriteChannelsSectionHeaderProps = {
  isExpanded: boolean
  favoritesCount: number
  onToggleExpand: (sectionId: string) => void
}

export const FavoriteChannelsSectionHeader = ({
  isExpanded,
  onToggleExpand,
  favoritesCount,
}: FavoriteChannelsSectionHeaderProps) => (
  <SectionHeader
    className="margin-top-smaller"
    sectionId={FAVORITE_CHANNELS_SECTION_ID}
    label={
      <>
        <span className="font-weight-bold">Favorites </span>
        <span className="flexbox flexbox-centered margin-left-smaller">
          <FavoriteIcon className="yellow" style={{ marginTop: 2 }} size={12} />
        </span>
        {isExpanded ? null : (
          <span className="margin-left-smaller shade-20 font-weight-medium">
            ({favoritesCount} hidden)
          </span>
        )}
      </>
    }
    isExpanded={isExpanded}
    onToggleExpand={onToggleExpand}
  />
)
